export const setCookie = (key, value) => {
  var expires = new Date(Date.now() + 86400 * 1000).toUTCString(); // expires in 1 day

  const domainString = location.host.includes("localhost")
    ? ""
    : `Domain=${location.host};`;
  document.cookie = `${key}=${value}; expires=${expires}; ${domainString} SameSite=Strict; Secure; path=/`;
};

export const getCookie = (key) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${key}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export const removeCookie = (key) => {
  const domainString = location.host.includes("localhost")
    ? ""
    : `Domain=${location.host};`;
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; ${domainString} SameSite=Strict; Secure; path=/`;
};
